export default __webpack_public_path__ + "static/media/icon-positive-check.4b9751d1.svg";